import script from "./action-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./action-card.vue?vue&type=script&setup=true&lang=ts"

import "./action-card.vue?vue&type=style&index=0&id=41be7b2e&lang=css"

const __exports__ = script;

export default __exports__